import { render, staticRenderFns } from "./ColdStorageUseRight.vue?vue&type=template&id=246bde5c&scoped=true&"
import script from "./ColdStorageUseRight.vue?vue&type=script&lang=js&"
export * from "./ColdStorageUseRight.vue?vue&type=script&lang=js&"
import style0 from "./ColdStorageUseRight.vue?vue&type=style&index=0&id=246bde5c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246bde5c",
  null
  
)

export default component.exports